export let awsSdkOptionsConfig= {
  region: process.env.USER_POOL_REGION
}

console.log("process.env.INTEGRATION_TEST_MODE=",process.env.INTEGRATION_TEST_MODE)

if (process.env.INTEGRATION_TEST_MODE && process.env.INTEGRATION_TEST_MODE.toLowerCase() === 'yes') {
  awsSdkOptionsConfig['endpoint'] = process.env.LOCALSTACK_ENDPOINT
}
